import { render, staticRenderFns } from "./DashBoardComponent.vue?vue&type=template&id=40c90e26&"
import script from "./DashBoardComponent.vue?vue&type=script&lang=js&"
export * from "./DashBoardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports